import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Github } from "lucide-react";

const Header = () => {
  return (
    <header className="bg-white dark:bg-gray-800 shadow-sm">
      <div className="container mx-auto flex flex-col gap-4 px-4 py-6 md:flex-row md:items-center md:justify-between">
        <Link to="/" className="text-2xl font-bold text-gray-800 dark:text-white">
          Skadisfinity Layout
        </Link>
        <nav className="flex flex-wrap items-center gap-3 text-sm font-medium text-gray-700 dark:text-gray-200">
          <Link className="hover:text-blue-600" to="/guide">
            Guide
          </Link>
          <Link className="hover:text-blue-600" to="/print-profiles">
            Print Profiles
          </Link>
          <Link className="hover:text-blue-600" to="/about">
            About
          </Link>
          <Button
            variant="ghost"
            className="px-2"
            onClick={() =>
              window.open(
                "https://github.com/trudrknight/Skadisfinity",
                "_blank"
              )
            }
          >
            <Github className="mr-2 h-5 w-5" />
            GitHub
          </Button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
